import { render, staticRenderFns } from "./TrainTable.vue?vue&type=template&id=050727fd&scoped=true"
import script from "./TrainTable.vue?vue&type=script&lang=js"
export * from "./TrainTable.vue?vue&type=script&lang=js"
import style0 from "./TrainTable.vue?vue&type=style&index=0&id=050727fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050727fd",
  null
  
)

export default component.exports